import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { CompetitionsDetail } from 'widgets/competitions-b2cr/detail/CompetitionDetail';

export const CompetitionB2CRDetailPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderAction('edit'));
    dispatch(setActionBtnTitle('Редактировать'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <CompetitionsDetail />;
};
